import React, { useState } from "react";

import { ALL_INVENTORY_ON_HAND_VIEW_QUERY } from "../../../graphql/Items/InventoryOnHand.graphql";

import DataTable from "../../../components/DataTable";
import { INVENTORY_ON_HAND_COLUMNS } from "./columns";

import PageHeader from "../../../components/PageHeader";

import InventoryOnHandFilters from "./InventoryOnHandFilters";
import { getFilterState, saveFilterState } from "../../../utils";
import {
  useAuthorization,
  useExactAuthorization
} from "../../../components/Authorization";

const InventoryOnHandsPage = () => {
  const INITIAL_FILTER_STATE = getFilterState("INVENTORY_ON_HAND_FILTERS", {
    ItemActive: true
  });
  const Auth = useAuthorization(["ADMIN", "FLEET", "MGMNT", "FIN", "MECH"]);

  const [filters, setFilters] = useState(INITIAL_FILTER_STATE);
  const handleSetFilters = inputs => {
    // Seting up the Filters values
    const Filters = {};
    Object.keys(inputs).forEach(
      key =>
        (Filters[key] =
          inputs[key] && inputs[key].value ? inputs[key].value : inputs[key])
    );
    if (Filters && Filters.ItemDescriptionRecIdRef) {
      delete Filters.ItemDescriptionRecIdRef;
      const itemSession = getFilterState("INVENTORY_ON_HAND_FILTERS");
      delete itemSession.ItemDescriptionRecIdRef;
      saveFilterState("INVENTORY_ON_HAND_FILTERS", {
        ...itemSession,
        ...Filters
      });
    }
    setFilters(Filters);
    saveFilterState("INVENTORY_ON_HAND_FILTERS", Filters);
  };
  const resetFilters = () => handleSetFilters({ Active: true });

  const isMechanicOnly = useExactAuthorization(["MECH"]);

  return (
    <React.Fragment>
      <PageHeader
        FilterComponent={InventoryOnHandFilters}
        columns={INVENTORY_ON_HAND_COLUMNS(Auth, isMechanicOnly)}
        filters={filters}
        name="VW_InventoryOnHands"
        query={ALL_INVENTORY_ON_HAND_VIEW_QUERY}
        resetFilters={resetFilters}
        setFilters={handleSetFilters}
        title="Item On-Hand"
      />
      <DataTable
        columns={INVENTORY_ON_HAND_COLUMNS(Auth, isMechanicOnly)}
        dataQuery={ALL_INVENTORY_ON_HAND_VIEW_QUERY}
        initialSortBy={[
          { id: "ItemNo", desc: false },
          { id: "LocationName", desc: true },
          { id: "InvDim1Code", desc: true },
          { id: "InvDim2Code", desc: true },
          { id: "InvDim3Code", desc: true }
        ]}
        name="VW_InventoryOnHand"
        where={filters}
      />
    </React.Fragment>
  );
};

InventoryOnHandsPage.propTypes = {};
export default InventoryOnHandsPage;
